import { IMetadata } from '../../Events/types';

export default (artist: { entity: IMetadata; code: number }): boolean =>
  artist.code !== 404;

export const notFoundEntity = (artist: {
  entity: IMetadata;
  code: number;
}): boolean => artist.code === 404;
